import Logo from "shared/Logo/Logo";
//import SocialsList1 from "shared/SocialsList1/SocialsList1";
import { CustomLink } from "data/types";
import React from "react";

export interface WidgetFooterMenu {
  id: string;
  title: string;
  menus: CustomLink[];
}

const widgetMenus: WidgetFooterMenu[] = [
  {
    id: "5",
    title: "Listen",
    menus: [
      { href: "https://anchor.fm/the-moon-crown",
        label: "Anchor" },
      { href: "https://podcasts.apple.com/us/podcast/the-moon-crown/id1630683271",
        label: "Apple Podcasts" },
      { href: "https://music.amazon.com/podcasts/f2f3744d-197e-4365-8325-e77d00123091/the-moon-crown",
        label: "Amazon Music" },
        { href: "https://pca.st/qnuuufrg", label: "Pocket Casts" },
      { href: "https://www.stitcher.com/show/711932",
        label: "Stitcher" },
      { href: "https://open.spotify.com/show/79GDG0T0dAJuY9SKRVbIeD",
        label: "Spotify" },

      
    ],
  },
  {
    id: "1",
    title: "Explore",
    menus: [
      { href: "https://twitter.com/TheMoonCrownPod", label: "Twitter" },
      { href: "https://www.instagram.com/themooncrownpod/", label: "Instagram" },
      { href: "https://themooncrownpod.tumblr.com/",
        label: "Tumblr silliness" }
    ],
  }
];

const Footer: React.FC = () => {
  const renderWidgetMenuItem = (menu: WidgetFooterMenu, index: number) => {
    return (
      <div key={index} className="text-sm">
        <h2 className="font-semibold text-neutral-700 dark:text-neutral-200">
          {menu.title}
        </h2>
        <ul className="mt-5 space-y-4">
          {menu.menus.map((item, index) => (
            <li key={index}>
              <a
                key={index}
                className="text-neutral-6000 dark:text-neutral-300 hover:text-black dark:hover:text-white"
                href={item.href}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <div className="relative py-20 border-t nc-Footer lg:pt-32 lg:pb-28 border-neutral-200 dark:border-neutral-700">
      <div className="container grid grid-cols-2 gap-y-10 gap-x-5 sm:gap-x-8 md:grid-cols-3 lg:gap-x-10 ">
        <div className="grid grid-cols-3 col-span-2 gap-5 md:col-span-4 lg:md:col-span-1 lg:flex lg:flex-col">
          <div className="col-span-2 md:col-span-1">
            <Logo />
          </div>
        </div>
        {widgetMenus.map(renderWidgetMenuItem)}
      </div>
    </div>
  );
};

export default Footer;
